/**
 * 二级代理轮播通知 mixin
 * - 每 3 秒切换一条
 * - 数据量 ≥ 2 条时开启向上无缝滚动轮播
 *
 * 组件需配合：
 * - props/data.notices: mapCarouselList 映射后的数组
 * - ref="noticeContent" 的 viewport 容器
 * - transition 绑定 noticeTransitionName
 */
const NOTICE_SWITCH_MS = 3000

export default {
  data() {
    return {
      noticeIndex: 0,
      noticeTimer: null,
    }
  },
  computed: {
    isRtlNotice() {
      return this.rtlLangs.includes(this.$i18n.locale)
    },
    currentNotice() {
      const notice = this.notices && this.notices[this.noticeIndex]
      return (
        notice || {
          timeLabel: { langKey: 'lang.Invite.k110', numsOption: [] },
          messageLangKey: 'lang.Invite.k109',
          messageNumsOption: [{ value: '' }],
        }
      )
    },
    noticeTransitionName() {
      return this.isRtlNotice ? 'notice-vertical-rtl' : 'notice-vertical'
    },
  },
  watch: {
    notices: {
      deep: true,
      handler() {
        this.restartNoticeCarousel()
      },
    },
  },
  mounted() {
    this.startNoticeCarousel()
  },
  beforeDestroy() {
    this.clearNoticeTimer()
  },
  methods: {
    clearNoticeTimer() {
      if (this.noticeTimer) {
        clearInterval(this.noticeTimer)
        this.noticeTimer = null
      }
    },
    restartNoticeCarousel() {
      this.clearNoticeTimer()
      this.noticeIndex = 0
      this.$nextTick(() => {
        this.startNoticeCarousel()
      })
    },
    startNoticeCarousel() {
      if (!this.notices || this.notices.length < 2) return
      this.clearNoticeTimer()
      this.noticeTimer = setInterval(() => {
        this.noticeIndex = (this.noticeIndex + 1) % this.notices.length
      }, NOTICE_SWITCH_MS)
    },
  },
}
